import React, { useContext } from 'react';
import { RicosViewerContext } from 'ricos-context';
import type { ComponentData, NodeViewRendererProps } from 'ricos-types';

import { LINK_PREVIEW_TYPE } from '../types';
import { LinkPreviewViewer } from './link-preview-viewer';

const LinkPreview = ({ node, nodeIndex, NodeViewContainer }: NodeViewRendererProps) => {
  const { helpers, iframeSandboxDomain, config } = useContext(RicosViewerContext);
  return (
    <NodeViewContainer node={node} nodeIndex={nodeIndex}>
      <LinkPreviewViewer
        nodeId={node.id}
        helpers={helpers}
        settings={config[LINK_PREVIEW_TYPE]}
        iframeSandboxDomain={iframeSandboxDomain || ''}
        componentData={(node.linkPreviewData || node.embedData) as ComponentData}
      />
    </NodeViewContainer>
  );
};

export default LinkPreview;
